export const SelectedArticlesPanel = {
  flow: 'y',
  hide: (el, s) => s.activeContent !== 'TUTORIALS',
  flexDirection: 'column',
  align: 'start start',
  round: 'A1',
  padding: 'Z2 Z2',
  position: 'relative',
  fontSize: 'Z1',
  childProps: {
    flex: '0 0 auto',
    width: '100%',
    minHeight: 'auto'
  },
  Flex: {
    flexDirection: 'column',
    H1: {
      fontSize: 'B2',
      padding: '- - Z -',
      color: 'title',
      fontWeight: '500',
      text: (el) => {
        const { name, username } = el.getRootState()
        return el.call('polyglot', 'learn.intro.greeting').replace('{name}', username || name || '')
      }
    },
    P: {
      color: 'paragraph',
      text: '{{ learn.articles.intro | polyglot }}'
    },
    Flex: {
      flow: 'y',
      // Gap replaces the per-row top divider (was `line` — border-habit
      // sweep, design-direction.md §8; §2.5 house rule: row separators
      // inside rounded cards stay banned — gap + hover tint instead).
      gap: 'X2',
      childProps: {
        padding: 'Z1 W',
        width: '100%',
        maxWidth: 'H1',
        round: 'radiusControl',
        transition: 'A defaultBezier padding',
        color: 'title',
        ':hover': { background: 'hover' },
        onClick: (ev, el) => {
          ev.preventDefault()
          ev.stopPropagation()
          el.setWindow('docs', el.href.split('/docs')[1])
        }
      },
      children: [
        {
          href: '/docs/intro',
          text: '{{ learn.articles.intro2 | polyglot }}'
        },
        {
          href: '/docs/components',
          text: '{{ learn.articles.firstComponents | polyglot }}'
        },
        {
          href: '/docs/pages',
          text: '{{ learn.articles.routing | polyglot }}'
        },
        {
          href: '/docs/how-to-code',
          text: '{{ learn.articles.howToCode | polyglot }}'
        },
        {
          href: '/docs/design-system',
          text: '{{ learn.articles.dsReference | polyglot }}'
        },
        {
          href: '/docs/element',
          text: '{{ learn.articles.elementApi | polyglot }}'
        },
        {
          href: '/docs/properties',
          text: '{{ learn.articles.customProps | polyglot }}'
        },
        {
          text: '{{ learn.articles.publishing | polyglot }}'
        },
        {
          text: '{{ learn.articles.importExport | polyglot }}'
        },
        {
          text: '{{ learn.articles.versioning | polyglot }}'
        },
        {
          text: '{{ learn.articles.branching | polyglot }}'
        },
        {
          href: '/docs/functions',
          text: '{{ learn.articles.functions | polyglot }}'
        },
        {
          href: '/docs/dependencies',
          text: '{{ editor.panel.dependencies | polyglot }}'
        }
      ]
    }
  }
}
